import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

export interface TextUrlFields {
    name?: EntryFieldTypes.Symbol;
    text?: EntryFieldTypes.Symbol;
    url?: EntryFieldTypes.Symbol;
    containsBookACallFunctionality?: EntryFieldTypes.Boolean;
    openNewTab?: EntryFieldTypes.Boolean;
}

export type TextUrlSkeleton = EntrySkeletonType<TextUrlFields, "textUrl">;
export type TextUrl<Modifiers extends ChainModifiers = "WITHOUT_UNRESOLVABLE_LINKS", Locales extends LocaleCode = LocaleCode> = Entry<TextUrlSkeleton, Modifiers, Locales>;

export function isTextUrl<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TextUrl<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'textUrl'
}
